import { updateBoundaryPosition } from '~core/expand';

/*
 * Config
 */
const maxOutpaintPercent = 50;

export default function enforceMinimumAndMaximumSize(
  canvas,
  boundaryRect,
  originalImage
) {
  if (!boundaryRect || !originalImage) {
    console.error(
      'enforceMinimumAndMaximumSize: no boundary rectangle or original image provided'
    );
    return;
  }

  const imgData = boundaryRect.imgData;
  if (!imgData) return;

  // Calculate current dimensions
  const currentWidth = boundaryRect.getScaledWidth();
  const currentHeight = boundaryRect.getScaledHeight();

  // Check if current dimensions are smaller than original image
  let needsUpdate = false;

  if (currentWidth < imgData.originalImgWidth) {
    const scaleX = imgData.originalImgWidth / boundaryRect.width;
    boundaryRect.set('scaleX', scaleX);
    needsUpdate = true;
  }

  if (currentHeight < imgData.originalImgHeight) {
    const scaleY = imgData.originalImgHeight / boundaryRect.height;
    boundaryRect.set('scaleY', scaleY);
    needsUpdate = true;
  }

  // Calculate maximum allowed dimensions based on percentage
  const maxAllowedWidth =
    imgData.originalImgWidth * (1 + maxOutpaintPercent / 100);
  const maxAllowedHeight =
    imgData.originalImgHeight * (1 + maxOutpaintPercent / 100);

  // Check if current dimensions exceed maximum allowed
  if (currentWidth > maxAllowedWidth) {
    const scaleX = maxAllowedWidth / boundaryRect.width;
    boundaryRect.set('scaleX', scaleX);
    needsUpdate = true;
  }

  if (currentHeight > maxAllowedHeight) {
    const scaleY = maxAllowedHeight / boundaryRect.height;
    boundaryRect.set('scaleY', scaleY);
    needsUpdate = true;
  }

  if (needsUpdate) {
    canvas.renderAll();
  }

  // Ensure the boundary contains the image after scaling
  updateBoundaryPosition(canvas, boundaryRect, originalImage);

  // Update info after enforcing size constraints
  // updateInfo();
}
